import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Tooltip,
  useMediaQuery
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { exportToExcel, fAlertToast } from '../../../Utility/Utilitys';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { DataGridPro, GridFooterContainer } from '@mui/x-data-grid-pro';
import {
  distributionItemLocationApi,
  distributionVANItemSaveApi,
  itemDistributionApi
} from '../../Purchase/actions';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import { useSelector } from 'react-redux';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export const ItemDistributionModal = ({ data, open, onClose, cardData, fVanDetail }) => {
  const vMediaQuery = useMediaQuery('max-width:900px');

  const rdxuser = useSelector((state) => state.SliceDB.value.login);
  const [location, setLocation] = useState([]);
  const [formData, setFormData] = useState(cardData);
  const [distributionRows, setDistributionRows] = useState([]);
  const [isLocationDisabled, setIsLocationDisabled] = useState(false);

  const totalQty = useMemo(() => {
    return distributionRows.reduce((sum, row) => sum + Number(row.qty || 0), 0);
  }, [distributionRows]);

  useEffect(() => {
    if (totalQty > 0) {
      setIsLocationDisabled(true);
    } else {
      setIsLocationDisabled(false);
    }
  }, [totalQty]);

  // useEffect(() => {
  //   if (open) {
  //     setFormData(cardData);

  //     setTimeout(() => {
  //       fLocation();
  //     }, [200]);

  //     if (cardData?.A_Loc !== '') {
  //       setFormData((prev) => ({
  //         ...prev,
  //         A_Loc: cardData?.A_Loc
  //       }));
  //     } else {
  //       setFormData((prev) => ({
  //         ...prev,
  //         A_Loc: location[0]?.UId
  //       }));
  //     }
  //     setTimeout(() => {
  //       fDetail(cardData?.A_TrnsId, cardData?.A_Loc);
  //     }, [800]);
  //     //  fDetail(cardData?.A_TrnsId, cardData?.A_Loc);
  //     // return () => clearTimeout(timer);
  //   }
  // }, [open, cardData]);

  useEffect(() => {
    if (open) {
      setFormData(cardData);

      const loadData = async () => {
        // Fetch and set locations first
        const newLoc = await fLocation();

        // Pick the correct A_Loc after locations are ready
        let selectedLoc = cardData?.A_Loc;
        if (!selectedLoc || selectedLoc === '') {
          selectedLoc = newLoc.length > 0 ? newLoc[0]?.UId : '';
        }

        // Set A_Loc to formData
        setFormData((prev) => ({
          ...prev,
          A_Loc: selectedLoc
        }));

        // Then load details (depends on location)
        // if (cardData?.A_TrnsId) {
        await fDetail(cardData?.A_TrnsId, selectedLoc);
        // }
      };

      loadData();
    }
  }, [open, cardData]);

  const fLocation = async () => {
    const obj = {
      VN_VocTyp: data?.A_VocTyp,
      VN_VocNo: data?.A_VocNo
    };

    const result = await distributionItemLocationApi(obj);

    if (result.Type === 'Success') {
      const locations = result?.ResultSet?.Location || [];
      setLocation(locations);
      return locations; // <-- return to caller
    } else {
      setLocation([]);
      return [];
    }
  };

  const fDetail = async (transID, xLoc) => {
    const obj = {
      TrnsId: transID,
      VocTyp: data?.A_VocTyp,
      VocNo: data?.A_VocNo,
      Truck: data?.TruckID,
      Loc: xLoc === '' ? location[0]?.UId : xLoc
    };

    const result = await itemDistributionApi(obj);

    if (result.Type === 'Success') {
      if (result?.ResultSet?.DistriRows.length > 0) {
        setDistributionRows(result?.ResultSet?.DistriRows);
      }
    } else {
      setDistributionRows([]);
      setLocation([]);
    }
  };

  const allQtyZero =
    distributionRows.length > 0
      ? distributionRows.every((row) => Number(row.qty) === 0 || row.qty === '' || row.qty === null)
      : true;

  const fSave = async (isPost) => {
    if (!formData?.A_Loc) {
      fAlertToast('FAILED', 'Location is Mandatory');
      return;
    }
    if (allQtyZero) {
      fAlertToast('FAILED', 'Qty should not be Zero in all columns');
      return;
    }
    const item = distributionRows?.map((row) => ({
      iTransID: formData?.A_TrnsId || cardData?.A_TrnsId,
      SrNo: row.B_SrNo,
      ITMCD: row.itmCd,
      B_QTY: row.qty,
      B_Unit: row.Unit,
      B_ReqQty: row.reqQty,
      B_VANQty: row.vanQty,
      balanceQty: row.balanceQty,
      B_UOM_PCS: row.B_UOM_PCS,
      B_UOM_PackQty: row.B_UOM_PackQty
    }));
    const obj = {
      A_TrnsId: formData?.A_TrnsId || cardData?.A_TrnsId,
      A_Loc: formData?.A_Loc,
      A_Date: moment(formData?.A_Date).format('MM/DD/YYYY'),
      A_Ref_VocTyp: data?.A_VocTyp,
      A_Ref_VocNo: data?.A_VocNo,
      A_Ref_Truck: data?.TruckID,
      Detail: item,
      isPost: isPost,
      userCd: rdxuser.userId
    };
    const result = await distributionVANItemSaveApi(obj);
    console.log(result, 'gggggg');

    if (result.Type === 'Success') {
      if (isPost === 'Y') {
        fAlertToast('SUCCESS', 'Posted Successfully');
        fClose();
        fVanDetail();
      } else {
        fAlertToast('SUCCESS', 'Saved Successfully');
      }
    }
    setIsLocationDisabled(true);
    setFormData((prev) => ({
      ...prev,
      A_TrnsId: result?.ResultSet?.TrnsId || cardData?.A_TrnsId
    }));
    if (formData?.A_TrnsId == 0) {
      fDetail(result?.ResultSet?.TrnsId, formData?.A_Loc);
    }
    fVanDetail();
  };

  const fPost = () => {
    if (allQtyZero) {
      fAlertToast('FAILED', 'Qty should not be Zero in all columns');
      return;
    }
    confirmAlert({
      title: 'Post',
      message: 'Are you sure to Post?',
      buttons: [
        {
          className: 'alertBtn',
          label: 'Yes',
          onClick: async () => {
            await fSave('Y');
          }
        },
        {
          className: 'alertBtn',
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  };

  const SetQty = ({ row, value }) => {
    const nextRow = { ...row, qty: value };
    setDistributionRows((prev) => prev?.map((itm) => (itm.B_SrNo === row.B_SrNo ? nextRow : itm)));
    return nextRow;
  };

  const isEnter = (e) => e.key === 'Enter' && !e.shiftKey;
  const isShiftEnter = (e) => e.key === 'Enter' && e.shiftKey;

  // jump focus by row delta (+1 next, -1 prev)
  const focusQtyDelta = (api, currentId, delta) => {
    const ids = api.getAllRowIds?.() || api.getSortedRowIds?.(); // v6 / v5
    if (!ids) return;
    const idx = ids.indexOf(currentId);
    const targetId = ids[idx + delta];
    if (targetId === undefined) return;

    api.setCellFocus?.(targetId, 'qty'); // focus cell
    // then focus the input inside it
    setTimeout(() => {
      const el = document.getElementById(`qty-${targetId}`);
      el?.focus();
      el?.select?.();
    }, 0);
  };
  const sanitizeQtyInput = (v) => (v === '' ? '' : String(v).replace(/[^\d]/g, ''));

  const columns = [
    { field: 'itmCd', headerName: 'Item Code', width: 100, flex: 1 },
    { field: 'ItmName', headerName: 'Item Name', width: 200, flex: 2 },
    {
      field: 'vanQty',
      headerName: 'Purchased',
      width: 90,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },
    {
      field: 'existingQty',
      headerName: 'TSR.Qty',
      width: 80,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },

    {
      field: 'balanceQty',
      headerName: 'Stock',
      width: 80,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },
    {
      field: 'reqQty',
      headerName: 'Required',
      width: 80,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },

    {
      field: 'SuggestedCTN',
      headerName: 'Suggested',
      width: 120,
      type: 'number',
      headerAlign: 'center',
      align: 'center',
      flex: 1
    },

    {
      field: 'qty',
      headerName: 'Qty',
      width: 120,
      headerAlign: 'center',
      type: 'number',
      cellClassName: 'editable-cell',
      renderCell: (params) => {
        const { row } = params;
        return (
          <TextField
            id={`qty-${params.id}`}
            name={params.field}
            autoComplete="off"
            value={row?.qty ?? ''} // controlled by state
            onKeyDown={(e) => {
              // stop grid nav
              if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.stopPropagation();
              }
              // block minus / exponent
              if (e.key === '-' || e.key.toLowerCase() === 'e') e.preventDefault();

              if (isEnter(e)) {
                e.preventDefault();
                e.stopPropagation();
                focusQtyDelta(params.api, params.id, +1);
              }
              if (isShiftEnter(e)) {
                e.preventDefault();
                e.stopPropagation();
                focusQtyDelta(params.api, params.id, -1);
              }
            }}
            onFocus={(e) => {
              e.stopPropagation();
              // 1) if value is 0 -> make it empty for easy overwrite
              if (row?.qty === 0 || row?.qty === '0') {
                SetQty({ ...params, value: '' });
                // sync the visible input immediately
                queueMicrotask(() => {
                  e.target.value = '';
                  e.target.select?.();
                });
              } else {
                // select all for quick typing
                queueMicrotask(() => e.target.select?.());
              }
            }}
            onChange={(e) => {
              e.stopPropagation();
              const raw = e.target.value;
              const next = raw === '' ? '' : sanitizeQtyInput(raw);
              SetQty({ ...params, value: next });
            }}
            onBlur={(e) => {
              e.stopPropagation();
              // 3) on blur: empty -> 0; else clamp to non-negative int
              let v = e.target.value;
              if (v === '') v = '0';
              let n = Number(v);
              if (!Number.isFinite(n) || n < 0) n = 0;
              n = Math.trunc(n);
              SetQty({ ...params, value: n });
            }}
            variant="outlined"
            size="small"
            inputProps={{
              inputMode: 'decimal',
              type: 'text', // <-- important: allow empty/backspace
              pattern: '[0-9]*[.]?[0-9]*',
              style: { textAlign: 'center' }
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-input': {
                textAlign: 'right',
                padding: '4px 12px',
                fontSize: '13px',
                backgroundColor: '#edfaff',
                borderRadius: '6px !important'
              }
            }}
          />
        );
      }
    },
    {
      field: 'B_UOM_PCS',
      headerName: 'PCS/CTN',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },
    { field: 'UnitName', headerName: 'Unit', width: 120, flex: 1 },
    {
      field: 'PackQty',
      headerName: 'PackQty',
      maxWidth: 90,
      headerAlign: 'center',
      align: 'center',
      flex: 1
    }
  ];

  const fClose = () => {
    setDistributionRows([]);
    setFormData({
      A_TrnsId: 0,
      A_Loc: '',
      locName: '',
      A_Date: new Date(),
      A_Ref_VocTyp: '',
      A_Ref_VocNo: '',
      A_Ref_Truck: '',
      A_Status: 'ENTER',
      ApBy: '',
      ApDt: ''
    });
    setIsLocationDisabled(false);
    onClose();
  };
  const handleExport = () => {
    exportToExcel(distributionRows, 'ItemList_data', 'ItemList');
  };

  return (
    <Dialog open={open} maxWidth="xl">
      <Toolbar sx={toolbar}>
        <DialogTitle
          sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0 2px !important' }}>
          Item Distribution
        </DialogTitle>
        <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <DialogContent
        sx={{
          '&.MuiDialogContent-root': { padding: '10px !important' },
          height: '80vh',
          overflowY: 'auto'
        }}>
        <Grid
          container
          columnSpacing={vMediaQuery ? 1 : 2}
          rowSpacing={vMediaQuery ? 1 : 2}
          sx={{ mt: 1, padding: vMediaQuery ? 0 : 1 }}>
          <Grid item xs={6} sm={3} md={2} lg={1.5}>
            <TextField
              label="Trans ID"
              fullWidth
              size="small"
              value={formData?.A_TrnsId} // directly from props/data
              InputProps={{ readOnly: true }}
              disabled
              sx={{
                '& .MuiInputBase-root .Mui-disabled': {
                  backgroundColor: '#f0f0f0 !important',
                  WebkitTextFillColor: 'rgb(0 0 0 / 84%) !important'
                },
                '& .MuiInputLabel-root': {
                  color: '#0d73bb !important'
                }
              }}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2} lg={1.5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                value={formData?.A_Date} // moment|null
                onChange={(value) => setFormData((prev) => ({ ...prev, TransDate: value }))}
                inputFormat="DD/MM/YYYY"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiInputLabel-root': {
                        color: '#0d73bb !important'
                      }
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={3.5} lg={2.6}>
            <FormControl
              fullWidth
              sx={{
                '& .MuiInputBase-root .Mui-disabled': {
                  backgroundColor: '#f0f0f0 !important',
                  WebkitTextFillColor: 'rgb(0 0 0 / 84%) !important'
                },
                '& .MuiInputLabel-root': {
                  color: '#0d73bb !important'
                }
              }}>
              <InputLabel>Location</InputLabel>
              <Select
                fullWidth
                size="small"
                disabled={isLocationDisabled}
                value={formData?.A_Loc || cardData?.A_Loc}
                onChange={(e) => {
                  const { value } = e.target;
                  setFormData((prev) => ({ ...prev, A_Loc: value }));
                  fDetail(formData.A_TrnsId, value);
                }}
                label="Location"
                displayEmpty>
                {location.map((loc) => (
                  <MenuItem key={loc.UId} value={loc.UId}>
                    {loc.Name1}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={9} md={4.5} lg={4.3}>
            <TextField
              label="Voucher"
              fullWidth
              size="small"
              value={`${data?.A_VocNo || ''} - ${data?.VocName || ''}`}
              InputProps={{ readOnly: true }}
              disabled
              sx={{
                '& .MuiInputBase-root .Mui-disabled': {
                  backgroundColor: '#f0f0f0 !important',
                  WebkitTextFillColor: 'rgb(0 0 0 / 84%) !important'
                },
                '& .MuiInputLabel-root': {
                  color: '#0d73bb !important'
                }
              }}
            />
          </Grid>
          <Grid item xs={5} sm={3} md={3} lg={2}>
            <TextField
              label="Ref.VouchorType"
              fullWidth
              size="small"
              value={data?.A_VocTyp}
              InputProps={{ readOnly: true }}
              disabled
              sx={{
                '& .MuiInputBase-root .Mui-disabled': {
                  backgroundColor: '#f0f0f0 !important',
                  WebkitTextFillColor: 'rgb(0 0 0 / 84%) !important'
                },
                '& .MuiInputLabel-root': {
                  color: '#0d73bb !important'
                }
              }}
            />
          </Grid>
          <Grid item xs={7} sm={5} md={3} lg={3} sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField
              label="Truck"
              fullWidth
              size="small"
              value={data?.TruckName || ''}
              InputProps={{ readOnly: true }}
              disabled
              sx={{
                '& .MuiInputBase-root .Mui-disabled': {
                  backgroundColor: '#f0f0f0 !important',
                  WebkitTextFillColor: 'rgb(0 0 0 / 84%) !important'
                },
                '& .MuiInputLabel-root': {
                  color: '#0d73bb !important'
                }
              }}
            />
          </Grid>
          <Grid item xs={7} sm={4.5} md={4.5} lg={7.5} sx={{ textAlign: 'right' }}>
            <Button
              variant="contained"
              size="small"
              onClick={() => fSave('N')}
              sx={{ textTransform: 'capitalize' }}
              disabled={cardData?.A_Status === 'POST'}>
              Save
            </Button>
          </Grid>
          <Grid item xs={3} sm={1.5} md={1} lg={1} sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              size="small"
              color="success"
              onClick={fPost}
              sx={{ textTransform: 'capitalize' }}
              disabled={cardData?.A_Status === 'POST'}>
              Post
            </Button>
          </Grid>
          <Grid item xs={1} sm={1} md={0.5} lg={0.5} mt={0.6}>
            <Tooltip title="Export">
              <IconButton
                color="primary"
                onClick={handleExport}
                size="small"
                sx={{
                  padding: 0,
                  '& .MuiSvgIcon-root': {
                    fontSize: '20px'
                  }
                }}>
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} mt={1}>
            <Box
              sx={{
                height: { xs: '45vh', sm: '55vh', md: '60vh', lg: '61vh' },
                width: '100%'
              }}>
              <DataGridPro
                className="gridTable"
                rowHeight={30}
                headerHeight={30}
                rows={distributionRows}
                columns={columns}
                getRowId={(row) => row.B_SrNo}
                disableRowSelectionOnClick
                components={{
                  Footer: () => (
                    <GridFooterContainer
                      sx={{
                        display: 'flex',
                        width: '100%',
                        borderTop: '1px solid #e0e0e0',
                        fontWeight: 600,
                        backgroundColor: '#f5f5f5'
                      }}>
                      {/* Left label cell */}
                      <div
                        style={{
                          flex: 1,
                          padding: '0 8px',
                          textAlign: 'right'
                        }}>
                        TOTAL QTY:
                      </div>
                      {/* Qty total cell */}
                      <div
                        style={{
                          width: 120, // match Qty column width
                          textAlign: 'center'
                        }}>
                        {totalQty.toFixed(0)}
                      </div>
                    </GridFooterContainer>
                  )
                }}
                disableSelectionOnClick
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
